import { useFormikContext } from 'formik';
import { groupBy } from 'lodash';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { getQuestions } from 'App/services/AssessmentQuestionService';
import assessmentSettingsPropType from '../../types/assessmentSettings';
import { noGroupOption, specialQuestions } from '../constants';
import convertAssessmentQuestionToView from '../utils/convertAssessmentQuestionToView';
import AssessmentManagerQuestionGroup from './AssessmentManagerQuestionGroup';

const AssessmentManagerQuestionsArea = ({ assessment }) => {
    const { assessmentId, parentAnswerId } = useParams();
    const { values, initialValues, setFieldValue } = useFormikContext();

    useEffect(() => {
        (async () => {
            const newQuestions = await getQuestions(assessmentId, { parentAnswerId });
            Object.values(newQuestions).forEach((q) => {
                if (!values.questions[q.question_id]) {
                    setFieldValue(`questions.${q.question_id}`, convertAssessmentQuestionToView(q));
                }
            });
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps -- only run when parentAnswerId changes
    }, [parentAnswerId]);

    const groupedQuestions = groupBy(
        Object.values(values.questions)
            .filter((q) => {
                return (
                    !specialQuestions.includes(q.name) &&
                    ((!q.parent_answer_id && !parentAnswerId) || q.parent_answer_id === parentAnswerId)
                );
            })
            .map((q) => ({
                ...q,
                initialGroup: initialValues.questions[q.question_id]?.group || noGroupOption,
            })),
        (q) => q.initialGroup.id
    );

    return Object.entries(groupedQuestions)
        .sort((a, b) => {
            return a[1][0].initialGroup.group_order - b[1][0].initialGroup.group_order;
        })
        .map(([id, list]) => (
            <AssessmentManagerQuestionGroup
                key={id}
                group={list[0].initialGroup}
                questions={list}
                assessment={assessment}
            />
        ));
};

AssessmentManagerQuestionsArea.propTypes = {
    assessment: assessmentSettingsPropType.isRequired,
};

export default AssessmentManagerQuestionsArea;
